module.exports = __webpack_public_path__ + "static/img/role.9cf1cee.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/role3/cz/role.png
// module id = NFks
// module chunks = 7